const t = {
  name: "Printer",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.25 11C19.25 11.69 18.69 12.25 18 12.25C17.31 12.25 16.75 11.69 16.75 11C16.75 10.31 17.31 9.75 18 9.75C18.69 9.75 19.25 10.31 19.25 11Z" fill="currentColor"/>
<path d="M5 1H19V6H20C21.6523 6 23 7.34772 23 9V16C23 17.6523 21.6523 19 20 19H19V23H5V19H4C2.34772 19 1 17.6523 1 16V9C1 7.34772 2.34772 6 4 6H5V1ZM17 3H7V6H17V3ZM4 8C3.45228 8 3 8.45228 3 9V16C3 16.5477 3.45228 17 4 17H5V14H19V17H20C20.5477 17 21 16.5477 21 16V9C21 8.45228 20.5477 8 20 8H4ZM7 21H17V16H7V21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Printer
};
